/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SysinfoPayload
 */
export interface SysinfoPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: SysinfoPayloadTypeEnum;
    /**
     * 
     */
    cpuPct: number;
    /**
     * 
     */
    memPct: number;
    /**
     * 
     */
    memUsedMb: number;
    /**
     * 
     */
    memTotalMb: number;
    /**
     * 
     */
    swapPct: number;
    /**
     * 
     */
    swapUsedMb: number;
    /**
     * 
     */
    swapTotalMb: number;
}


/**
 * @export
 */
export const SysinfoPayloadTypeEnum = {
    Sysinfo: 'sysinfo',
} as const;
export type SysinfoPayloadTypeEnum = typeof SysinfoPayloadTypeEnum[keyof typeof SysinfoPayloadTypeEnum];


/**
 * Check if a given object implements the SysinfoPayload interface.
 */
export function instanceOfSysinfoPayload(value: object): value is SysinfoPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'sysinfo') return false;
    
    if ((!('cpuPct' in (value as Record<string, any>)) && !('cpu_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['cpuPct'] === undefined && (value as Record<string, any>)['cpu_pct'] === undefined)) return false;
    if ((!('memPct' in (value as Record<string, any>)) && !('mem_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['memPct'] === undefined && (value as Record<string, any>)['mem_pct'] === undefined)) return false;
    if ((!('memUsedMb' in (value as Record<string, any>)) && !('mem_used_mb' in (value as Record<string, any>))) || ((value as Record<string, any>)['memUsedMb'] === undefined && (value as Record<string, any>)['mem_used_mb'] === undefined)) return false;
    if ((!('memTotalMb' in (value as Record<string, any>)) && !('mem_total_mb' in (value as Record<string, any>))) || ((value as Record<string, any>)['memTotalMb'] === undefined && (value as Record<string, any>)['mem_total_mb'] === undefined)) return false;
    if ((!('swapPct' in (value as Record<string, any>)) && !('swap_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['swapPct'] === undefined && (value as Record<string, any>)['swap_pct'] === undefined)) return false;
    if ((!('swapUsedMb' in (value as Record<string, any>)) && !('swap_used_mb' in (value as Record<string, any>))) || ((value as Record<string, any>)['swapUsedMb'] === undefined && (value as Record<string, any>)['swap_used_mb'] === undefined)) return false;
    if ((!('swapTotalMb' in (value as Record<string, any>)) && !('swap_total_mb' in (value as Record<string, any>))) || ((value as Record<string, any>)['swapTotalMb'] === undefined && (value as Record<string, any>)['swap_total_mb'] === undefined)) return false;
    return true;
}

export function SysinfoPayloadFromJSON(json: any): SysinfoPayload {
    return SysinfoPayloadFromJSONTyped(json, false);
}

export function SysinfoPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SysinfoPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'cpuPct': json['cpu_pct'],
        'memPct': json['mem_pct'],
        'memUsedMb': json['mem_used_mb'],
        'memTotalMb': json['mem_total_mb'],
        'swapPct': json['swap_pct'],
        'swapUsedMb': json['swap_used_mb'],
        'swapTotalMb': json['swap_total_mb'],
    };
}

export function SysinfoPayloadToJSON(json: any): SysinfoPayload {
    return SysinfoPayloadToJSONTyped(json, false);
}

export function SysinfoPayloadToJSONTyped(value?: SysinfoPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'cpu_pct': value['cpuPct'],
        'mem_pct': value['memPct'],
        'mem_used_mb': value['memUsedMb'],
        'mem_total_mb': value['memTotalMb'],
        'swap_pct': value['swapPct'],
        'swap_used_mb': value['swapUsedMb'],
        'swap_total_mb': value['swapTotalMb'],
    };
}

